export default "__VITE_ASSET__BUKMe7qO__"